const routePath = {
	LOGIN: "/login",
	HOME: "/",
	PROFILE: "/profile",
	DASHBOARD: "/dashboard",
	TRANSACTION_HISTORY_CONTAINER: "/transaction-history",
	PENDING_TRANSACTIONS_CONTAINER: "/pending-transactions",
	REPORTS: "/reports",
};

export default routePath;
